export const Api_EndPoints = {
  PayrollURL: "",
  // Login: "/CPFContributionAPI/CPFContribution/UserValidation",

  VerifyEmail: "/AuthenticationAPI/ForgotPassword",
  VerifyOTP: "/AuthenticationAPI/NewPasswordAccess",
  ResetPassword: "/AuthenticationAPI/ResetUserPassword",
  GetAllCompany: "/EmployeeStatusAPI/GetAllCompany",
  Login: "/AuthenticationAPI/UserValidation",
  LoginHistory: "/AuthenticationAPI/UserLoginHistory",
  Logout: "/AuthenticationAPI/UpdateUserLoginHistoryStatus",
  DashboardDetails: "/EmployeeAPI/Employee/GetDashBoardCount",
  AttendanceDashboard: "/EmployeeAPI/DashBoardCount",
  // NewDashBoard: "/EmployeeAPI/NewDashBoard",
  NewDashBoard: "/EmployeeAPI/NewDashBoardV1",
  CPFContributionAPI: "/CPFContributionAPI",
  GetCPFContributionRates: "/CPFContributionRatesAPI/GetCPFContributionRates",
  CPFContributionRateAPI: "/CPFContributionRatesAPI",
  UserNameValidation: "/AuthenticationAPI/UserEmailValidation",
  CPFPercentageAPI: "/CPFPercentageAPI",
  InsertMultipleCpfpercentage: "/CPFPercentageAPI/InsertCpfpercentage",
  CPFPercentageFLIAPI: "/CPFPercentageForLowIncomeAPI",
  InsertMultipleCpfpercentageFLI:
    "/CPFPercentageForLowIncomeAPI/InsertCpfpercentageForLowIncome",
  // GetAllCPFTypes: "/ResidentialTypeAPI/GetAllCPFType",
  // InsertCPFType: "/ResidentialTypeAPI/InsertCPFType",
  // UpdateCPFType: "/ResidentialTypeAPI/UpdateCPFType",
  GetAllCPFTypes: "/CPFTypeAPI/GetAllCPFType",
  InsertCPFType: "/CPFTypeAPI/InsertCPFType",
  UpdateCPFType: "/CPFTypeAPI/UpdateCPFType",
  LocationAPI: "/LocationAPI",
  GetAllPassType: "/PassTypeAPI",
  PassTypeAPI: "/PassTypeAPI",
  GetAllPaymode: "/PayrollHeaderAPI/GeAllPaymode",
  InsertPaymode: "/PayrollHeaderAPI/InsertPaymode",
  UpdatePaymode: "/PayrollHeaderAPI/UpdatePaymode",
  DeletePaymode: "/PayrollHeaderAPI/DeletePaymode",
  GetEmployeeList: "/EmployeeAPI/Employee/GetAllEmployee",
  GetEmployeesWorkingHours: "/EmployeeAPI/GetEmployeesWorkingHours",
  CreateOrModifyEmployee:
    "/EmployeeAPI/Employee/CreateOrModifyEmployeesDetails",
  ImportEmployees: "/EmployeeAPI/ImportEmployeeDetailsNew",
  GetEmployeeDetails: "/EmployeeAPI/Employee/GetEmployeesDetails",
  DeleteEmployee: "/EmployeeAPI/Employee/DeleteEmployeeDetails",
  EmpUserValidation: "/AuthenticationAPI/UserCreationValidation",
  GetNationalities: "/NationalityAPI/Nationality/GetAllNationality",
  GetRaces: "/RaceAPI/Race/GetAllRace",
  GetRelations: "/RelationshipAPI/Relationship/GetAllRelationship",
  GetCountries: "/CountryAPI/Country/GetAllCountry",
  GetResidentialTypes: "/InventoryAPI/GetAllResidentialType",
  GetIdentifications: "IdentificationAPI/Identification/GetAllIdentification",
  GetAcademics: "/AcademicAPI/GetAllAcademic",
  AcademicAPI: "/AcademicAPI",
  BankAPI: "/BankAPI",
  CountryAPI: "/CountryAPI",
  RaceAPI: "/RaceAPI",
  VisaType: "/VisaTypeAPI",
  NationalityAPI: "/NationalityAPI",
  RelationshipAPI: "/RelationshipAPI",
  IdentificationAPI: "/IdentificationAPI",
  LoanAPI: "/LoanAPI",
  // GetCPFTypes: "/ResidentialTypeAPI/GetAllCPFType",
  GetCPFTypes: "/CPFTypeAPI/GetAllCPFType",
  GetPassTypes: "/PassTypeAPI",
  GetDepartments: "/DepartmentAPI",
  GetDesignations: "/DesignationAPI",
  GetAdditions: "/PayrollAdditionAPI",
  GetDeductions: "/PayrollDeductionAPI",
  // GetLeaveTypes: "/LeaveMasterAPI",
  GetPaymodes: "/PayrollHeaderAPI/GeAllPaymode",
  GetCpfContributions: "/CPFContributionAPI",
  AddDepartment: "/DepartmentAPI",
  GetDepartmentByID: "/DepartmentAPI",
  UpdateDepartment: "/DepartmentAPI",
  AddDesignation: "/DesignationAPI",
  GetDesignationtByID: "/DesignationAPI",
  UpdateDesignation: "/DesignationAPI",
  GetEmpAllocatedLeave: "/EmployeeAPI/GetEmpAllocatedLeave",
  GetRequestedLeaves: "/EmployeeLeaveDataAPI/EmployeeLeaveData/GetApplyLeave",
  GetApprovedLeaves: "/EmployeeLeaveDataAPI/EmployeeLeaveData/GetApprovedLeave",
  // GetRejectedLeaves: "/EmployeeLeaveDataAPI/EmployeeLeaveData/GetRejectedLeave",
  GetRejectedLeaves: "/EmployeeLeaveDataAPI/RejectedLeaves",
  GetEmpLeave: "/EmployeeLeaveDataAPI/EmployeeLeaveData/GetEmpLeave",
  GetEmployeeLeaveData:
    "/EmployeeLeaveDataAPI/EmployeeLeaveData/GetEmployeeLeaveMaster",
  // SaveApplyLeave: "/EmployeeLeaveDataAPI/EmployeeLeaveData/Pay_LeaveSave",
  SaveApplyLeave: "/EmployeeLeaveDataAPI/Pay_LeaveSaveNew",
  ApproveLeave: "/EmployeeLeaveDataAPI/EmployeeLeaveData/Pay_LeaveApprove",
  RejectLeave: "/EmployeeLeaveDataAPI/EmployeeLeaveData/Pay_LeaveDelete",
  GetLeaveTypes: "/EmployeeLeaveMasterAPI/GetLeaveCode",
  InsertLeaveMaster:
    "/EmployeeLeaveMasterAPI/EmployeeLeaveMaster/InsertLeaveMaster",
  UpdateLeaveMaster:
    "/EmployeeLeaveMasterAPI/EmployeeLeaveMaster/UpdateLeaveMaster",
  UpdateEmployeeLeave: "/EmployeeAPI/Employee/UpdateEmployeeLeave",
  PublicHolidays: "/EmployeeLeaveMasterAPI/GetPublicHoliday",
  InsertPublicHoliday:
    "/EmployeeLeaveMasterAPI/EmployeeLeaveMaster/InsertPublicHoliday",
  UpdatePublicHoliday:
    "/EmployeeLeaveMasterAPI/EmployeeLeaveMaster/UpdatePublicHoliday",
  GetEmpAttendanceBydate:
    "/EmployeePayrollDataAPI/EmployeePayrollData/GetEmpAttendancedate",
  GetEmpAttendanceList: "EmployeePayrollDataAPI/GetEmpAttendanceList",
  AddAttendance: "/EmployeePayrollDataAPI/EmployeePayrollData/CreateAttendance",
  CreateMonthlyAttendance:
    "/EmployeePayrollDataAPI/EmployeePayrollData/CreateMonthlyAttendance",
  GetTimesheetData:
    "/EmployeePayrollDataAPI/EmployeePayrollData/GetMonthlyEmployeeAttendanceData",
  PayrollAddition: "/PayrollAdditionAPI",
  PayrollDeduction: "/PayrollDeductionAPI",
  GeneratePayroll: "/PayrollDetailAPI/PayrollDetails/GeneratePayrollDetails",
  ReGeneratePayroll:
    "/PayrollDetailAPI/PayrollDetails/ReGeneratePayrollDetails",
  SavePayroll: "/PayrollDetailAPI/PayrollDetail/PayrollHeaderDetailSave",
  MonthlyPayrollDetails:
    "/PayrollDetailAPI/PayrollDetail/TrackMonthlyHistoryDetails",
  GetPayrollDetails: "/PayrollDetailAPI/PayrollDetail/GetPayrollDetails",
  AttendanceDetailReport:
    "/EmployeePayrollDataAPI/EmployeePayrollData/GetAttendanceDetailReport",
  GetLeaveDetails: "/PayrollDetailAPI/PayrollDetail/GetLeaveDetails",
  GetMonthlyWiseSummary:
    "/PayrollDetailAPI/PayrollDetail/GetMonthlyWiseSummary",
  GetPayslipReport: "/PayrollDetailAPI/PayrollDetail/GetPayslip",
  GetExpiryDocReport: "/EmployeeAPI/GetEmpExpiryReport",
  GetEmpContractReport:
    "/EmployeePayrollDataAPI/EmployeePayrollData/GetEmpContractReport",
  GetEmpProjectReport:
    "/EmployeePayrollDataAPI/EmployeePayrollData/GetProjectWiseReport",
  EmployeeProjectDetailsReport:
    "/EmployeePayrollDataAPI/EmployeePayrollData/EmployeeProjectDetailsReport",
  ManHourProjectReport: "/EmployeeAPI/GetMonthlyManHourReport",
  ForeCastReport: "/PayrollDetailAPI/ForeCastReport",
  EmployeesLevyReport: "/EmployeeAPI/GetEmployeesLevyReport",
  // GetPayslipReport: "/PayrollDetailAPI/PayrollDetail/GetPayslip",
  // GetCompanySetting: "/EmployeeStatusAPI/Company/GetCompanySetting",
  GetCompanySetting: "/EmployeeStatusAPI/GetCompanyDetailswithuser",
  // UpdateCompanySetting:
  //   "/EmployeeStatusAPI/EmployeeStatus/UpdateCompanySettings",
  UpdateCompanySetting: "/EmployeeStatusAPI/UpdateCompanyAndUsers",
  InsertClaimType: "/ClaimTypeAPI/Claims/InsertClaimsTypes",
  GeAllClaimTypes: "/ClaimTypeAPI/Claims/GeAllClaimTypes",
  GetClaimTypes: "/ClaimTypeAPI/Claims/GetClaimTypes",
  UpdateClaimsTypes: "/ClaimTypeAPI/Claims/UpdateClaimsTypes",
  DeleteClaimTypes: "/ClaimTypeAPI/Claims/DeleteClaimTypes",
  InsertClaims: "/ClaimAPI/Claims/InsertClaims",
  UpdateClaims: "/ClaimAPI/Claims/UpdateClaims",
  DeleteClaims: "/ClaimAPI/Claims/DeleteClaims",
  GetClaim: "/ClaimAPI/Claims/GetClaim",
  GeAllClaims: "/ClaimAPI/Claims/GeAlltClaim",
  EmpClaimDetails: "/PayrollDetailAPI/PayrollDetail/EmpClaimDetails",
  GetEmpPayrollAddition: "/EmployeeAPI/GetEmpPayrollAddition",
  GetEmpPayrollDeduction: "/EmployeeAPI/GetEmpPayrollDeduction",
  EmpAdditionCreation: "/EmployeeAPI/EmployeePayrollAdditionCreation",
  EmpAdditionUpdate: "/EmployeeAPI/Employee/EmployeePayrollAdditionUpdate",
  EmpDeductionCreation: "/EmployeeAPI/EmployeePayrollDeductionCreation",
  EmpDeductionUpdate: "/EmployeeAPI/Employee/EmployeePayrollDeductionUpdate",
  GetAllShiftType: "/ShiftTypeMasterAPI/GetAllShiftTypeMaster",
  GetShiftType: "/ShiftTypeMasterAPI/GetShiftTypeMaster",
  InsertShiftType: "/ShiftTypeMasterAPI/InsertShiftTypeMaster",
  UpdateShiftType: "/ShiftTypeMasterAPI/UpdateShiftTypeMaster",
  DeleteShiftType: "/ShiftTypeMasterAPI/DeleteShiftTypeMaster",
  GetAllShiftPolicy: "/ShiftPolicyAPI/GetAllShiftPolicy",
  GetShiftPolicy: "/ShiftPolicyAPI/GetShiftPolicy",
  InsertShiftPolicy: "/ShiftPolicyAPI/InsertShiftPolicy",
  UpdateShiftPolicy: "/ShiftPolicyAPI/UpdateShiftPolicy",
  DeleteShiftPolicy: "/ShiftPolicyAPI/DeleteShiftPolicy",
  GetAllGroup: "/GroupAPI/Group/GetAllGroup",
  InsertGroup: "/GroupAPI/Group/SaveGroup",
  UpdateGroup: "/GroupAPI/Group/UpdateGroup",
  DeleteGroup: "/GroupAPI/Group/DeleteGroup",
  GetAllProject: "/ProjectsAPI/Projects/GetAllProject",
  GetProject: "/ProjectsAPI/Projects/GetProjectDetails",
  InsertProject: "/ProjectsAPI/Projects/SaveProject",
  UpdateProject: "/ProjectsAPI/Projects/UpdateProject",
  DeleteProject: "/ProjectsAPI/Projects/DeleteProject",
  GetEmployeeJobList: "/JobsAPI/Jobs/GetEmployeeJobList",
  GetAllJob: "/JobsAPI/Jobs/GetAllJobs",
  GetJobsDetails: "/JobsAPI/Jobs/GetJobsDetails",
  InsertJob: "/JobsAPI/Jobs/SaveJobs",
  UpdateJob: "/JobsAPI/Jobs/UpdateJobs",
  DeleteJob: "/JobsAPI/Jobs/DeleteJobs",
  ShiftScheduleCreation: "/ShiftScheduleAPI/ShiftScheduleCreation",
  GetShiftSchedule: "/ShiftScheduleAPI/GetShiftSchedule",
  ShiftRotationCreation: "/ShiftScheduleAPI/ShiftRotationCreation",
  GetShiftRotation: "/ShiftScheduleAPI/GetShiftRotation",
  GetUserMasters: "/AuthenticationAPI/GetAllUserMaster",
  GetUserMaster: "/AuthenticationAPI/GetUserMaster",
  InsertUserMaster: "/AuthenticationAPI/InsertUserMaster",
  UpdateUserMaster: "/AuthenticationAPI/UpdateUserMaster",
  DeleteUserMaster: "/AuthenticationAPI/DeleteUserMaster",
  // GetUserRoles: "/CPFContributionAPI/CPFContribution/GetAllUserRole",
  // GetUserRole: "/CPFContributionAPI/CPFContribution/GetUserRole",
  // InsertUserRole: "/CPFContributionAPI/CPFContribution/InsertUserRole",
  // UpdateUserRole: "/CPFContributionAPI/CPFContribution/UpdateUserRole",
  // DeleteUserRole: "/CPFContributionAPI/CPFContribution/DeleteUserRole",
  GetUserGroups: "/AuthenticationAPI/GetAllUserGroup",
  GetUserGroup: "/AuthenticationAPI/GetUserGroup",
  InsertUserGroup: "/AuthenticationAPI/InsertUserGroup",
  UpdateUserGroup: "/AuthenticationAPI/UpdateUserGroup",
  DeleteUserGroup: "/AuthenticationAPI/DeleteUserGroup",
  GetUserRoles: "/AuthenticationAPI/UserRoles",
  GetUserRolesAccess: "/AuthenticationAPI/UserRolesAcess",
  SaveUserRole: "/AuthenticationAPI/UserRoleSave",
  LevyTypeAPI: "/LevyTypeAPI",
  ForeignerLevyTypeAPI: "/ForeignerlevyAPI",
  LevyAmountTypeAPI: "/LevyAmountTypeAPI",
  GetAttendanceTimeLog: "/EmployeePayrollDataAPI/GetAttendanceTimeLog",
  PayrollStagingHeaderDetailSave:
    "/PayrollDetailAPI/PayrollStagingHeaderDetailSave",
  PayrollStagingList: "/PayrollDetailAPI/PayrollStagingList",
  PayrollStagingDetails: "/PayrollDetailAPI/PayrollStagingDetails",
  GetStagingPayrollDetails: "/PayrollDetailAPI/GetStagingPayrollDetails",
  PayrollStagingHeaderDetailUpdate:
    "/PayrollDetailAPI/PayrollStagingHeaderDetailUpdate",
  CreateTimeLogAttendance: "/EmployeePayrollDataAPI/CreateTimeLogAttendance",
  GetAttendanceTimeLogDetails:
    "/EmployeePayrollDataAPI/GetAttendanceTimeLogDetails",
  CreateBulkAttendance:
    "/EmployeePayrollDataAPI/EmployeePayrollData/CreateBulkAttendance",
  UpdateBulkAttendance: "/EmployeePayrollDataAPI/UpdateBulkAttendance",
  GetEmployeeSalaryHike:
    "/EmployeeSalaryHikeAPI/EmployeeSalaryHike/GetEmployeeSalaryHike",
  GetEmployeeAdvanceList: "/EmployeeAPI/GetEmployeeAdvancePaymentList",
  PutEmployeeAdvancePayment: "/EmployeeAPI/EmployeeAdvancePaymentUpdate",
  GetEmpPayrollAdditionandDeductions:
    "/EmployeeAPI/GetEmpPayrollAdditionandDeductions",
  EmployeePayrollAdditionAndDeductionCreation:
    "/EmployeeAPI/EmployeePayrollAdditionAndDeductionCreation",
  EmployeePayrollAdditionAndDeductionUpdate:
    "/EmployeeAPI/EmployeePayrollAdditionAndDeductionUpdate",
  ImportEmpAllowanceAndDeduction:
    "/EmployeeAPI/ImportEmpPayrollAdditionAndDeduction",
  EmploymentType: "/EmploymentTypeAPI",
  ContractType: "/ContractTypeAPI",
  GetAllContractPolicy: "/ContractPolicyAPI/GetAllContractPolicy",
  GetContractPolicy: "/ContractPolicyAPI/GetContractPolicy",
  InsertandUpdateContractPolicy:
    "/ContractPolicyAPI/InsertandUpdateContractPolicy",
  GetAllContractVariables: "/ContractPolicyAPI/GetAllContractVariables",
  GenerateContractPolicy: "/ContractPolicyAPI/GenerateContractPolicy",
  TradeAPI: "/TradeAPI",
  MOMTrade: "/MOMTradeAPI",
  Dormitory: "/DormitoryAPI",
  GetAllDormitory: "/DormitoryAPI/Dormitory/GetAllDormitory",
  AdavancePaymentReport: "/EmployeeAPI/GetAdavancePaymentList",
  EmpContractReport:
    "/EmployeePayrollDataAPI/EmployeePayrollData/GetEmpContractReport",
  ProjectWiseReport:
    "/EmployeePayrollDataAPI/EmployeePayrollData/GetProjectWiseReport",
  RepaymentList: "/EmployeeAPI/GetRepaymentList",
  EmployeeSalaryHike: "/EmployeeSalaryHikeAPI",
  // EmployeeSalaryHikeUpdate: "/EmployeeAPI/EmployeeSalaryHikeUpdate",
  EmployeeStatus: "/EmployeeStatusAPI",
  WorkingDaysType: "/WorkingDaysTypeAPI",
  EmployeeType: "/EmployeeTypeAPI",
  EmployeeWorkType: "/EmployeeWorkTypeAPI",
  GetEmployeeId: "/EmployeeAPI/GetEmployeeID",
  UserValidation: "/AuthenticationAPI/UserValidation",
  GetUserLoginHistory: "/AuthenticationAPI/GetUserLoginHistory",
  GetUserCompanyList: "/CompanyAccessAPI/GetCompanyList",
  VehicleAccident: "/VehicleAccidentAPI",
  // GetAllVehicleDetails: "/VehicleAccidentAPI/GetAllVehicleDetails",
  InsertVehicleDetails: "/VehicleInformationAPI/InsertAllVehicleDetails",
  UpdateVehicleDetails: "/VehicleInformationAPI/UpdateAllVehicleDetails",
  VehicleInformation: "/VehicleInformationAPI",
  GetAllVehicleDetails: "/VehicleInformationAPI/GetAllVehicleDetails",
  DieselUsage: "/DieselUsageAPI",
  VehicleMaintenance: "/VehicleMaintenanceAPI",
  VehicleType: "/VehicleTypeAPI",
  VehicleExpenses: "/VehicleExpensesAPI",
  VehicleIndemnity: "/VehicleIndemnityAPI",
  VehicleCategory: "/VehicleCategoryAPI",
  GetForeignerlevy: "/ForeignerlevyAPI",
  GetInsuranceType: "/InsuranceTypeAPI",
  ResetDevice: "/EmployeeAPI/ResetDevice",
  UpdateEmployeeLockStatus: "/EmployeeAPI/UpdateEmployeeLockStatus",
  EmployeePasswordReset: "/EmployeeAPI/EmployeePasswordReset",
  GetEmpLeaveHistory: "/EmployeeLeaveDataAPI/GetEmpLeaveHistory",
  GetEmployeesLevyReport: "/EmployeeAPI/GetEmployeesLevyReport",
  GetProjectAdditionandDeductionsReport:
    "/EmployeeAPI/ProjectAdditionandDeductionsReport",
  LoginNew: "/AuthenticationAPI/UserValidationNew",
  GetUserRolesNew: "/AuthenticationAPI/UserRolesNew",
  GetUserRolesAccessNew: "/AuthenticationAPI/UserRolesAcessNew",
  SaveUserRoleNew: "/AuthenticationAPI/UserRoleSaveNew",
  WTROTAdjustWaitingTime:
    "/EmployeePayrollDataAPI/PayrollDetails/WTROTAdjustWaitingTime",
  AdjustWaitingTime: "/EmployeePayrollDataAPI/PayrollDetails/AdjustWaitingTime",
  GetDefaultAllowanceList: "/EmployeeAPI/GetDefaultAllowanceList",
  GetEmployeeCountList: "/EmployeeAPI/GetCountList",
  GetAllEmailSetting: "/EmailSettingAPI/GetAllEmailSetting",
  GetEmailSetting: "/EmailSettingAPI/GetEmailSetting",
  InsertEmailSetting: "/EmailSettingAPI/InsertEmailSetting",
  UpdateEmailSetting: "/EmailSettingAPI/UpdateEmailSetting",
  EmployeeReportList: "/EmployeeAPI/GetAllEmployeeReports",
  ReGenerateAndSavePayrollStaging:
    "/PayrollDetailAPI/PayrollDetails/ReGenerateAndSavePayrollStaging",
  GetAllEmailModule: "/EmailSettingAPI/GetAllEmailModule",
  EmpAppliedLeavesList: "/EmployeeLeaveDataAPI/EmpAppliedLeavesList",
  EmpLeavesList: "/EmployeeLeaveDataAPI/EmpLeavesList",
  GetCompanyListforClient: "/EmployeeStatusAPI/GetCompanyListforClient",
  GetKetInformation: "/MobileAppRepositoryAPI/EmployeeKETFormDetails",
  UpdateKETInformation: "/MobileAppRepositoryAPI/EmployeeKETFormUpdate",
  GenerateKETForm: "/MobileAppRepositoryAPI/GenerateKETForm",
  GetEmployeeLogin: "/EmployeeAPI/GetAllEmployeeLogin",
  GetAuditLogList: "/EmployeeAPI/GetAuditLogList",
  GetAuditLog: "/EmployeeAPI/GetAuditLog",
  GetEmployeeOfferLetterList: "/EmployeeAPI/GetEmployeeOfferLetterList",
  GetEmployeeOfferLetter: "/EmployeeAPI/GetEmployeeOfferLetter",
  CreateOfferLetter: "/EmployeeAPI/CreateOfferLetter",
  UpdateOfferLetter: "/EmployeeAPI/UpdateOfferLetter",
  InsertAnnouncement: "/AnnouncementAPI/InsertAnnouncement",
  GetAllAnnouncement: "/AnnouncementAPI/GetAllAnnouncement",
  GetAnnouncementByID: "/AnnouncementAPI/GetAnnouncement",
  UpdateAnnouncement: "/AnnouncementAPI/UpdateAnnouncement",
  DeleteAnnouncement: "/AnnouncementAPI/DeleteAnnouncement",
  QREncryption: "/EmployeeAPI/QREncryption",
  AllCompanies_DashBoard: "/AllCompaniesAPI/NewDashBoardV1",
  AllCompanies_EmployeeReports: "/AllCompaniesAPI/GetAllEmployeeReports",
  AllCompanies_GetEmpPayrollAdditionandDeductions:
    "/AllCompaniesAPI/GetEmpPayrollAdditionandDeductions",
  AllCompanies_GetEmployeeAdvancePaymentList:
    "/AllCompaniesAPI/GetEmployeeAdvancePaymentList",
  AllCompanies_GetAttendanceDetailReport:
    "/AllCompaniesAPI/GetAttendanceDetailReport",
  AllCompanies_GetEmpLeaveHistory: "/AllCompaniesAPI/GetEmpLeaveHistory",
  AllCompanies_GetMonthlyWiseSummary: "/AllCompaniesAPI/GetMonthlyWiseSummary",
  AllCompanies_GetPayslip: "/AllCompaniesAPI/GetPayslip",
  AllCompanies_GetForeCastReport: "/AllCompaniesAPI/ForeCastReport",
  AllCompanies_GetEmployeesLevyReport:
    "/AllCompaniesAPI/GetEmployeesLevyReport",
  AllCompanies_GetEmpContractReport: "/AllCompaniesAPI/GetEmpContractReport",
  AllCompanies_GetEmployeesExpiryReport: "/AllCompaniesAPI/GetEmpExpiryReport",
  AllCompanies_GetMonthlyManHourReport:
    "/AllCompaniesAPI/GetMonthlyManHourReport",
  AllCompanies_GetCountListReport: "/AllCompaniesAPI/GetCountList",
  AllCompanies_GetProjectWiseReport: "/AllCompaniesAPI/GetProjectWiseReport",
  AllCompanies_GetProjectCostingReport:
    "/AllCompaniesAPI/GetProjectCostingReport",
  AllCompanies_GetUnAppliedLeaveEmployees:
    "/AllCompaniesAPI/GetUnAppliedLeaveEmployees",
  GetUnAppliedLeaveEmployees: "/EmployeeAPI/GetUnAppliedLeaveEmployees",

  GetProjectCostingReport: "/PayrollDetailAPI/GetProjectCostingReport",
  GetBankPaymentList: "/PayrollDetailAPI/GetBankPaymentList",
  GetAllIR8AForms: "/TaxSubmissionAPI/GetAllIR8AForms",

  GetNotifications: "/AuthenticationAPI/GetNotificationHistory",
  UpdateNotification: "/AuthenticationAPI/UpdateNotificationHistory",
  ClearAllNotifications: "/AuthenticationAPI/UpdateNotificationStatus",
  GetAttentionRequiredCountList: "/EmployeeAPI/GetAttentionRequiredCountList",
  GetEmployeeMovementCountList: "/EmployeeAPI/GetEmployeeMovementCountList",
  SalaryUpdateReGenerate: "/PayrollDetailAPI/SalaryUpdateReGenerate",
  ReCalculatePayrollGeneration:
    "/PayrollDetailAPI/ReCalculatePayrollGeneration",
  UpdatePaymentDate: "/PayrollDetailAPI/UpdatePaymentDate",
  UpdateStagingPayroll: "/PayrollDetailAPI/EditStagingPayroll",
  TimeLogWeelyOffAttendance:
    "/EmployeePayrollDataAPI/TimeLogWeelyOffAttendance",
};
